export default __webpack_public_path__ + "static/media/whopper-deliveroo.76695898.png";